module.exports = __webpack_public_path__ + "img/language.e5df2f1f.svg";